import { ErrorHandler, Injectable, inject } from '@angular/core';
import { LoggingService } from '../services/logging.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private loggingService = inject(LoggingService);

  handleError(error: any): void {
    const errorMessage = error?.message || (typeof error === 'object' ? JSON.stringify(error) : String(error));
    this.loggingService.logException(errorMessage, 3, 'GlobalErrorHandler');
    console.error('GlobalErrorHandler:', error);
  }
}
